var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-tool-bar"},[_c('div',{staticClass:"win-operate-list clearfix"},[_c('div',{staticClass:"button-item pull-left min",on:{"click":function($event){return _vm.onOperateClicked('min')}}}),_c('div',{staticClass:"button-item pull-left close",on:{"click":function($event){return _vm.onOperateClicked('close')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }